import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { useOperationConfigModelStore } from '@/models/operation-config/operationConfig';
import React from 'react';

export function useCalcNotificationHeight() {
  const notification = useDocsDataModelStore((x) => x.notification);
  const hiddenTopNotificationIds = useOperationConfigModelStore((x) => x.hiddenTopNotificationIds);

  const notificationHeight = React.useMemo(() => {
    const list = notification.filter((x) => !hiddenTopNotificationIds.includes(x.id));

    return list.length * 38;
  }, [notification, hiddenTopNotificationIds]);

  return notificationHeight;
}
